module.exports = __webpack_public_path__ + "static/media/white_red3.18a6be65.jpg";